module.exports = __webpack_public_path__ + "img/asd8150233.2a3d482a.png";